// jshint: es6
import './tab.css';

const Tabs = ({move, stage, setStage, count, modes, clear}) => {
    const controls = ["All", "Active", "Completed"];
    const doFilter = (e) =>{
        const {id} = e.target;
        move(id)
        setStage(id)
    }
    const onClear = () => {
        clear()
    }
    return(
        <div>
            <div className={ modes ? "tabs" : "tabs lite"}>
                <p className="no-items" id="no-items">{count} items left</p>
                <div className="controls" id="controls">
                    {controls.map((control, index)=>{
                        return (
                            <span
                                key={control}
                                id={control}
                                className={ stage === control? "control active": "control"}
                                onClick={doFilter}
                            >{control}</span>
                        )
                    })}
                </div>
                
                <p className="clear" id="clear" onClick={onClear}>Clear Completed</p>
            </div>
            
        </div>
    
    )
}
export default Tabs;